export const FAILED_PUBLISH_LABEL = {
  // недостаточно денег,
  MONEY: 'not_enough_money',
  // неавторизован
  UNAUTHORIZED: 'not_identificated',
  // не заполнены обязательные поля
  UNFILLED: 'requreid_field_unfilled',
  // неправильно заполнены обязательные поля
  MISFILLED: 'requreid_field_misfilled',
  // непонятная ошибка
  UNKNOWN: 'unknown',
  // отсутствии в ответе от API подачи адреса для редиректа
  NO_REDIRECT: 'no_redirect',
  // ошибка перед публикацией объявления при проверке параметров публикации
  PREPUBLISH: 'check_publish_error',
};
